export const CAPABILITY_KEYS = {
  ORGANIZATION_PROFILE: 'organization-profile',
  ORGANIZATION_USERS: 'organization-users',
  FORMS: 'forms',
  SAVED_SEARCHES: 'saved-searches',
  VIEW_DOCUMENTS: 'view-documents',
};

export const CAPABILITY_ROUTE_MAP = {
  [CAPABILITY_KEYS.FORMS]: '/client-portal-forms',
  [CAPABILITY_KEYS.SAVED_SEARCHES]: '/saved-searches',
  [CAPABILITY_KEYS.VIEW_DOCUMENTS]: '/client-portal-documents',
};
